import React from 'react';
import { ReactComponent as AlertIcon } from 'v2/icons/alert-icon-blue.svg';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import styles from './freeSearchTooltip.module.css';
import { RootState } from 'v2/models';
import { useSelector } from 'react-redux';

const WAITLIST_MESSAGE = `We are reviewing your account. Once approved, your request will 
be released to our database of providers.`;

const UNVERIFIED_EMAIL_MESSAGE = `Please verify your email, then we will begin reviewing 
your account. Once approved, your request will be released to our database of providers.`;

interface FreeSearchTooltipProps {
  isFreeSearch: boolean;
}

export const FreeSearchTooltip = ({ isFreeSearch }: FreeSearchTooltipProps) => {
  const user = useSelector((state: RootState) => state.user.user);
  const emailVerified = user.auth0_email_verified;
  const waitlisted = user.waitlisted;

  if (!isFreeSearch) {
    return null;
  }

  if (emailVerified && !waitlisted) {
    return null;
  }

  return (
    <div className="mr-2">
      <OverlayTrigger
        placement={'top'}
        overlay={
          <Popover id="free-search-popover" className={styles.popover}>
            <Popover.Content className={styles.popoverBody}>
              {!emailVerified
                ? UNVERIFIED_EMAIL_MESSAGE
                : waitlisted
                ? WAITLIST_MESSAGE
                : null}
            </Popover.Content>
          </Popover>
        }
      >
        <AlertIcon />
      </OverlayTrigger>
    </div>
  );
};
